import React from 'react'
import PropTypes from 'prop-types'
import TimeRangeRaw from '~/components/common/TimeRange'

const TimeRange = ({ field, form, disabled, ...props }) => (
  <TimeRangeRaw
    disabled={disabled || !!form.values.__readOnly}
    {...field}
    {...props}
  />
)

TimeRange.defaultProps = {
  disabled: false,
}

TimeRange.propTypes = {
  field: PropTypes.shape().isRequired,
  form: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
}

export default TimeRange
